import baseApi from "../../../Lib/api/baseApi";
import endpoints from "../../../Lib/api/endpoints";
import { isDisplayableActiveRider } from "../../../Lib/riders";

export const DashboardApi = baseApi.injectEndpoints({
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (details) => ({
        ...endpoints.createOrder,
        data: details,
      }),
      invalidatesTags: [{ type: "Orders", id: "LIST" }],
    }),
    getNearestRider: builder.query({
      query: (data) => ({
        ...endpoints.getNearbyRider(data),
      }),
    }),
    getRiderLocation: builder.query({
      query: (id) => ({
        ...endpoints.getRiderLocation(id),
      }),
      transformResponse: (response) => ({
        lat: response?.data?.latitude,
        lng: response?.data?.longitude,
      }),
    }),
    getActiveRiders: builder.query({
      query: () => ({
        ...endpoints.getActiveRiders,
      }),
      transformResponse: (response) => ({
        ...response,
        data: (response?.data || []).filter(isDisplayableActiveRider),
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useLazyGetNearestRiderQuery,
  useGetRiderLocationQuery,
  useLazyGetActiveRidersQuery,
  useGetActiveRidersQuery,
} = DashboardApi;
